
import { defineComponent, onBeforeUnmount, onMounted } from 'vue'

export default defineComponent({
    name: 'ScheduledChangeBlockedModal',
    props: {
        opened: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close'],
    setup(props, { emit }) {
        const close = () => emit('close')
        const handleKeydown = (event: KeyboardEvent) => {
            if (!props.opened || event.key !== 'Escape') return
            close()
        }

        onMounted(() => {
            document.addEventListener('keydown', handleKeydown)
        })
        onBeforeUnmount(() => {
            document.removeEventListener('keydown', handleKeydown)
        })

        return { close }
    },
})
